<template>
	<div>
		<div :style="{ height: isMobileOrTablet ? '0' : searchHeight + 'px' }"></div>
		<div class="topSearchs" ref="searchTops" :style="{ left: getIsCollapseStatus ? '64px' : '200px' }">
			<div class="topSearch space_between">
				<el-form class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
							range-separator="～" start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.mediaCompany" filterable clearable size="small" placeholder="请选择媒体公司" @change="companySelectChange">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.os" clearable size="small" style="width:210px" placeholder="请选择系统">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-select v-model="queryData.appId" filterable clearable size="small" style="width:210px"
							placeholder="请选择应用">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :value="item"
								:label="`应用：${item.label} | ${item.value}`">
								<!-- :label="`应用：${item.label} | ${item.value}`" -->
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.type" clearable size="small" style="width:210px" placeholder="请选择广告类型">
							<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-select v-model="queryData.adsId" clearable size="small" style="width:210px">
							<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-select v-model="adsSelectForm" clearable @change="adsSeleteChange" size="small" value-key="value" style="width: 280px;"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable @clear="getMediaAdsOption(2)"
							:remote-method="adsRemoteMethod" :loading="adsRemoteLoading" remote placeholder="请选择聚合广告位">
							<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="`广告位：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isMediumRole">
						<el-select v-model="queryData.platformId" filterable clearable size="small" @change="networkOptionsChange" placeholder="请选择广告网络">
							<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label" :value="item.platformId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isMediumRole">
						<el-select v-model="queryData.platformNetworkId" filterable clearable size="small" @change="networkAccountChange"
						placeholder="请选择账号名称">
							<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isMediumRole">
						<!-- <el-input clearable size="small" style="width:210px" placeholder="请输入广告源"
							v-model="queryData.adsId"></el-input> -->
						<el-select v-model="adsSelectFormChannel" clearable @change="channelAdsSeleteChange" size="small"
							value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable style="width: 280px;"
							@clear="getChannelAdsOption(2)" :remote-method="channelAdsRemoteMethod" :loading="adsRemoteLoading" remote
							placeholder="请选择广告源">
							<el-option v-for="(item,index) in channelAdsOptions" :key="index" :label="`广告源：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isMediumRole">
						<el-select v-model="queryData.sdkVersion" clearable size="small" style="width:210px"
							placeholder="请选择聚合SDK版本">
							<el-option v-for="item in sdkVersionOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isMediumRole">
						<el-select v-model="queryData.appProperty" clearable size="small" placeholder="请选择应用属性">
							<el-option v-for="item in appPropertyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div class="searchMenuRight">
					<el-button type="primary" @click="confirmQuery" size="small"
						v-hasPermi="['dataReport:comprehensiveReport:query']">查询</el-button>
					<div></div>
					<el-button @click="searchReset" size="small" v-hasPermi="['dataReport:comprehensiveReport:query']">重置</el-button>
				</div>
			</div>
		</div>
		<div class="mianPage">
			<!-- 图表 -->
			<div class="chartsBox">
				<div class="chartsRow flex_start">
					<div class="chartsTips">数据图表</div>
					<el-select v-model="chartsQueryData.checked1" filterable clearable size="small" style="margin-left: auto;"
						placeholder="请选择" @change="chartsSelectChange($event,1)" @clear="chartsClear(1)">
						<el-option v-for="item in chartsSelectList" :key="item.prop" :label="item.label" :value="item.prop"
						:disabled="item.isDisable">
						</el-option>
					</el-select>
					<el-select v-model="chartsQueryData.checked2" filterable clearable size="small" style="margin-left: 20px;"
						placeholder="选择对比" @change="chartsSelectChange($event,2)" @clear="chartsClear(2)">
						<el-option v-for="item in chartsSelectList" :key="item.prop" :label="item.label" :value="item.prop"
						:disabled="item.isDisable">
						</el-option>
					</el-select>
				</div>
				<div class="" id="lineChart"></div>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="tHeadRow flex_start">
					<div class="tHeadleftTips">查看维度</div>
					<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
					style="margin-right: 30px;">全选</el-checkbox>
					<el-checkbox-group v-model="tHeaderQueryChecked" class="tHeadFixedCheckList">
						<el-checkbox v-for="(item,index) in visibleTHeaderQueryData" :label="item.valueNum" size="mini"
							:checked="item.checked" :key="index" :name="item.value" class="check-box-fixed"
							@change="checkBoxQueryChange($event,item,index)">{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
					<div class="tableBtns">
						<el-button @click="editTheadDialog" size="small"><i class="el-icon-setting"></i>
							自定义指标</el-button>
						<el-button size="small" plain v-hasPermi="['dataReport:comprehensiveReport:export']"
						@click="appExport"><i class="el-icon-upload2"></i> 导出</el-button>
					</div>
				</div>
				<div class="dimensionalityCheckedTips flex_start" v-if="(hasChecked && hasRequiredPropsPUV) || (hasThChannelProps && hasMediaProps)">
					<img src="../../assets/icon/tipsIconTh.png" alt="" />
					<div>当前筛选条件下，不支持部分指标数据展现。</div>
				</div>
				<div class="dimensionalityCheckedTips flex_start" v-if="hasRequiredProps">
					<img src="../../assets/icon/tipsIconTh.png" alt="" />
					<div>通过报表API同步的数据存在T+1延迟，当日广告网络数据无法获取。</div>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table" @selection-change="handleSelectionChange" ref="multipleTable"
					@expand-change="handleExpandChange" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass"
					:row-class-name="tableRowClassName">
					<!-- 动态维度列使用唯一 key，避免切换维度时复用旧列内容 -->
					<el-table-column key="recordTime" prop="recordTime" sortable="custom" label="日期" :fixed="shouldFixDimensionColumn" min-width="100"
						v-if="tHeaderQueryChecked.indexOf(1) !== -1"></el-table-column>
					<el-table-column key="companyName" prop="companyName" label="媒体公司" :fixed="shouldFixDimensionColumn" min-width="160"
						v-if="tHeaderQueryChecked.indexOf(2) !== -1"></el-table-column>
					<el-table-column key="os" prop="os" label="操作系统" :fixed="shouldFixDimensionColumn" min-width="90"
						v-if="tHeaderQueryChecked.indexOf(3) !== -1"></el-table-column>
					<el-table-column key="mediaAppId" prop="appName" label="应用" :fixed="shouldFixDimensionColumn" min-width="160"
						v-if="tHeaderQueryChecked.indexOf(4) !== -1">
						<template slot-scope="scope">
							<div v-if="scope.row.mediaAppId">
								<div>{{scope.row.mediaAppName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.mediaAppId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column key="type" prop="type" label="广告类型" :fixed="shouldFixDimensionColumn" min-width="130"
						v-if="tHeaderQueryChecked.indexOf(5) !== -1">
						<template slot-scope="scope">
							<span>{{getAdTypeRenderText(scope.row)}}</span>
						</template>
					</el-table-column>
					<el-table-column key="mediaAdId" prop="" label="聚合广告位" :fixed="shouldFixDimensionColumn" min-width="180"
						v-if="tHeaderQueryChecked.indexOf(6) !== -1">
						<template slot-scope="scope">
							<div v-if="scope.row.mediaAdId">
								<div>{{scope.row.mediaAdName}}</div>
								<div style="color: #4F7AFD;">{{scope.row.mediaAdId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column key="platformNetworkId" prop="platformName" label="广告网络" :fixed="shouldFixDimensionColumn" min-width="120"
						v-if="tHeaderQueryChecked.indexOf(8) !== -1"></el-table-column>
					<el-table-column key="platformAdId" prop="" min-width="180" label="广告源" :fixed="shouldFixDimensionColumn" v-if="tHeaderQueryChecked.indexOf(9) !== -1">
						<template slot-scope="scope">
							<div v-if="scope.row.platformAdId">
								<div>{{scope.row.platformAdName}}</div>
								<div style="color: #999999;">{{scope.row.platformAdId}}</div>
							</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column key="sdkVersion" prop="sdkVersion" label="聚合SDK版本" min-width="160" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(7) !== -1"></el-table-column>
					<el-table-column key="platformVersion" prop="platformVersion" label="广告网络SDK版本" min-width="160" :fixed="shouldFixDimensionColumn"
						v-if="tHeaderQueryChecked.indexOf(11) !== -1"></el-table-column>
					<!-- <el-table-column v-for="(columnObj,index) in tHeadCheckedList" :key="index" v-if="columnObj.checked == true"
						:prop="columnObj.prop" :label="columnObj.label" align="right" :width="columnObj.width"
						:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false">
					</el-table-column> -->
					<template v-for="(columnObj,index) in tHeadCheckedList">
						<template v-if="columnObj.prop == 'pv'||columnObj.prop == 'uv'">
							<el-table-column v-if="!hasChecked" :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template>
						<template v-else-if="columnObj.prop == 'deu'">
							<el-table-column v-if="hasChecked" prop="deu" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
							<el-table-column v-else prop="appDeu" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template>
						<!-- <template
							v-else-if="columnObj.prop == 'platformReqNum'||columnObj.prop == 'platformSuccNum'||columnObj.prop == 'platformSuccReqRate'||columnObj.prop == 'platformSuccShowRate'">
							<el-table-column v-if="hasMediaProps" :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template> -->
						<template
							v-else-if="columnObj.prop == 'reqNum'||columnObj.prop == 'succNum'||columnObj.prop == 'succReqRate'||columnObj.prop == 'succShowRate'">
							<el-table-column v-if="!hasMediaProps" :prop="columnObj.prop" :label="columnObj.label" align="right"
								:width="columnObj.width" :fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false"
								:key="index" :min-width="columnObj.minWidth">
							</el-table-column>
						</template>
						<template v-else>
							<el-table-column :prop="columnObj.prop" :label="columnObj.label" align="right" :width="columnObj.width"
								:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
								<!-- <template v-slot="scope" v-if="columnObj.temp">
									<slot :name="columnObj.prop" :scope="scope" v-if="['reqGapRate', 'reqSuccGapRate', 'showGapRate',
									'clickGapRate','ecpmGapRate','incomeGapRate'].includes(columnObj.prop)">
										<div v-if="scope.row[columnObj.prop] !== null">{{scope.row[columnObj.prop]}}%</div>
										<div v-else>-</div>
									</slot>
								</template> -->
							</el-table-column>
						</template>
					</template>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 分渠道数据 -->
		<el-drawer @close="closeDrawer" :visible.sync="channelDataDrawerShow" size="65%" :wrapperClosable="false"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">分渠道数据</div>
					<i class="el-icon-circle-close" @click="channelDataDrawerShow=false"></i>
				</div>
				<el-form inline class="el-form flex_start">
					<el-form-item label="日期">
						<el-date-picker v-model="datePickerDrawer" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="渠道广告位ID/名称：">
						<el-input clearable size="small" style="width:210px" placeholder="请输入"
							v-model="queryDataDrawer.adsId"></el-input>
					</el-form-item>
					<!-- <el-form-item label="广告类型：">
						<el-select v-model="queryData.syncStatus" clearable size="small" style="width:210px">
							<el-option v-for="item in syncStatusOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item> -->
					<div class="menu-right">
						<!-- <el-button @click="searchReset" size="small" v-hasPermi="['dataManage:mediaIncome:query']">重置</el-button> -->
						<el-button type="primary" @click="confirmDrawerQuery" size="small"
							v-hasPermi="['dataManage:mediaIncome:query']">查询</el-button>
					</div>
				</el-form>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableDataDrawer"
					class="el_table" ref="multipleTables">
					<el-table-column prop="recordTime" label="日期"></el-table-column>
					<el-table-column prop="companyName" label="媒体广告位名称"></el-table-column>
					<el-table-column prop="name" label="渠道广告位名称" width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.adName">{{scope.row.adName}}/{{scope.row.adsId}}</div>
							<div v-else>-</div>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="请求量"></el-table-column>
					<el-table-column prop="os" label="请求成功量"></el-table-column>
					<el-table-column prop="appName" label="后台展现量"></el-table-column>
					<el-table-column prop="cooperationType" label="展现差异率"></el-table-column>
					<el-table-column prop="showNum" label="后台点击量" width="110" align="center"></el-table-column>
					<el-table-column prop="showNum" label="点击差异率" width="110" align="center"></el-table-column>
					<el-table-column prop="channelEstimateProfit" label="收益"></el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChangeDrawer" background @current-change="handleCurrentChangeDrawer"
						:current-page="currentPageDrawer" :page-sizes="[10, 20, 30, 50]" :page-size="pageSizeDrawer"
						layout="total, sizes, prev, pager, next, jumper" :total="totalDrawer">
					</el-pagination>
				</div>
				<div class="card-bottom flex_end">
					<el-button @click="closeDrawer" type="primary" size="medium">关闭</el-button>
				</div>
			</el-card>
		</el-drawer>
		<!-- <el-dialog title="媒体信息" :visible.sync="dialogVisible"
		  width="30%">
		  <span>这是一段信息</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog> -->
		<el-dialog title="自定义指标" :visible.sync="tHeadDialogVisible" width="56%">
			<div class="tHeadEditBox space_between">
				<div class="tHeadAllList">
					<el-collapse v-model="activeNames">
						<el-collapse-item :title="item.name" :name="index" v-for="(item,index) in tHeadAllList" :key="index">
							<div class="checkList">
								<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.groupChecked" class="el_check_box"
									@change="handleGroupCheckChange($event,item,index)" style="width: 100%;">全选</el-checkbox>
								<el-checkbox v-for="(items,indexs) in item.list" :key="indexs" size="medium"
									@change="checkChange($event,index,items,indexs)" v-model="items.checked" class="el_check_box">
									{{items.label}}
								</el-checkbox>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="tHeadCheckShowBox">
					<div class="tHeadCheckShowTitle">已选指标</div>
					<div class="tHeadCheckShowTips">上下拖动可调整排序</div>
					<div class="tHeadCheckShowList" v-show="tHeadCheckShowList.length>0">
						<div class="tHeadCheckedOne flex_start" v-for="(item,index) in tHeadCheckShowList" :key="index"
							@dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
							@dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)" :draggable="true">
							<img src="../../assets/icon/sort.png" alt="" />
							<!-- <i class="el-icon-notebook-2"></i> -->
							<div>{{item.label}}</div>
							<i class="el-icon-close" style="margin-left: auto;" @click.stop="deleteTHeadChecked(item,index)"></i>
						</div>
					</div>
					<el-empty description="暂无数据" v-show="tHeadCheckShowList.length<=0"></el-empty>
				</div>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeTHeadDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="confirmTHeadDialog()" size="medium">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				companyDrawerShow: false,
				isDimensionIndeterminate: true,
				dimensionCheckAll: false,
				handleSelection: "", // 存储ID
				datePicker: [],
				adTypeSelectData: [],
				companyOptions: [], // 公司下拉选择列表
				osOptions: this.$api.osOptions, // OS下拉选择列表
				syncStatusOptions: [{
						value: '1',
						label: '已同步'
					},
					{
						value: '0',
						label: '未同步'
					}
				], // 同步状态下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型下拉选择
				appPropertyOptions: this.$api.appPropertyOptions, // 应用属性下拉选择列表
				networkOptions: [], // 广告网络下拉列表
				accountOptions: [], // 账号名称下拉选择列表
				mediaAdsOptions: [], //广告位下拉选择
				adsSelectForm: {}, //广告位下拉选中数据
				channelAdsOptions: [], //渠道广告位下拉列表
				adsSelectFormChannel: {}, //渠道广告位下拉选中数据
				adsRemoteLoading: false,
				chartsQueryData: {
					checked1: 'estimateProfit'
				},
				sdkVersionOptions: [
					{label: '1.8.4',value: '1.8.4'},
					{label: '3.3.4',value: '3.3.4'},
				],
				queryData: {
					platformNetworkId: '',
					appProperty: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				companyFormData: {},

				dialogVisible: false, // 弹框显隐
				sortField: {},
				orderBys: [],

				channelDataDrawerShow: false,
				datePickerDrawer: [],
				currentPageDrawer: 1,
				pageSizeDrawer: 10,
				totalDrawer: 0,
				adsIdDrawer: '',
				queryDataDrawer: {},
				tableDataDrawer: [],

				chartsSelectList: [],

				expandedRows: [],

				// tHeaderQueryChecked: ['recordTime', 'companyName', 'os', 'mediaAppId', 'type', 'mediaAdId'],
				tHeaderQueryChecked: [1, 2, 3, 4, 5, 6],
				tHeaderQueryData: [{
						value: 'recordTime',
						valueNum: 1,
						label: "日期",
						checked: false
					},
					{
						value: 'companyName',
						valueNum: 2,
						label: "媒体公司",
						checked: false
					},
					{
						value: 'os',
						valueNum: 3,
						label: "操作系统",
						checked: false
					},
					{
						value: 'mediaAppId',
						valueNum: 4,
						label: "应用",
						checked: false
					},
					{
						value: 'type',
						valueNum: 5,
						label: "广告位类型",
						checked: false
					},
					{
						value: 'mediaAdId',
						valueNum: 6,
						label: "聚合广告位",
						checked: false
					},
					{
						value: 'platformNetworkId',
						valueNum: 8,
						label: "广告网络",
						checked: false
					},
					{
						value: 'platformAdId',
						valueNum: 9,
						label: "广告源",
						checked: false
					},
					{
						value: 'sdkVersion',
						valueNum: 7,
						label: "聚合SDK版本",
						checked: false
					},
					{
						value: 'platformVersion',
						valueNum: 11,
						label: "广告网络SDK版本",
						checked: false
					},
				],

				tHeadDialogVisible: false,
				activeNames: [0, 1, 2],
				tHeadAllList: [{
						name: '统计指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [
							{
								prop: 'channelEstimateProfit',
								label: "总收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'estimateProfit',
								label: "媒体收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'divideEstimateProfit',
								label: "分成收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'reqNum',
								label: "流量请求量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'succNum',
								label: "流量返回量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'succReqRate',
								label: "流量填充率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'showNum',
								label: "展示量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'succShowRate',
								label: "流量展示率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'platformReqNum',
								label: "广告请求量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'avgReqNum',
								label: "人均请求量",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'platformSuccNum',
								label: "广告返回量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'platformSuccReqRate',
								label: "广告填充率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'platformSuccShowRate',
								label: "广告展示率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'deductClickNum',
								label: "点击量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'deductClickRate',
								label: "点击率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'channelEcpm',
								label: "总收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'ecpm',
								label: "媒体收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'pv',
								label: "PV",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'uv',
								label: "UV",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
							{
								prop: 'deu',
								label: "DEU",
								checked: false,
								sortable: false,
								minWidth: '120',
							},
						]
					},
					{
						name: 'API指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'apiIncome',
								label: "API收益(￥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiReqNum',
								label: "API请求量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiSuccNum',
								label: "API返回量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiSuccRate',
								label: "API填充率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiShowNum',
								label: "API展示量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiUniqueClickNum',
								label: "API点击量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiUniqueClickRate',
								label: "API点击率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiEcpm',
								label: "API eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
						]
					},
					{
						name: '数据GAP',
						groupChecked: false,
						isIndeterminate: false,
						list: [{
								prop: 'reqGapRate',
								label: "请求GAP率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'reqSuccGapRate',
								label: "返回GAP率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'showGapRate',
								label: "展示GAP率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'clickGapRate',
								label: "点击GAP率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'ecpmGapRate',
								label: "eCPM GAP率",
								checked: false,
								sortable: true,
								width: '120',
							},
							{
								prop: 'incomeGapRate',
								label: "收益GAP率",
								checked: false,
								sortable: true,
								width: '120',
							},
						]
					}
				],
				tHeadCheckShowList: [], // 表头选中临时展示列表
				tHeadCheckedList: [], //最终选中的表头展示数组
				// 默认展示的表头
				tHeadNormalCheckedList: [{
						prop: 'pv',
						label: "PV",
						checked: true,
						sortable: false,
						minWidth: '120'
					},
					{
						prop: 'uv',
						label: "UV",
						checked: true,
						sortable: false,
						minWidth: '120'
					},
					{
						prop: 'channelEstimateProfit',
						label: "总收益(¥)",
						checked: false,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'estimateProfit',
						label: "媒体收益(¥)",
						checked: false,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'divideEstimateProfit',
						label: "分成收益(¥)",
						checked: false,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'reqNum',
						label: "流量请求量",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'succNum',
						label: "流量返回量",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'succReqRate',
						label: "流量填充率",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'showNum',
						label: "展示量",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'succShowRate',
						label: "流量展示率",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'deductClickNum',
						label: "点击量",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'deductClickRate',
						label: "点击率",
						checked: true,
						sortable: true,
						minWidth: '120'
					},
					{
						prop: 'ecpm',
						label: "媒体收益eCPM(¥)",
						checked: true,
						sortable: true,
						minWidth: '140'
					},
				],
				dragging: null,
				isMobileOrTablet: false, // 是否为平板或手机端，移动端不固定非展开列
				tableFixedMediaQuery: null, // 表格固定列的媒体查询对象


				lineChartsXData: [],
				lineChartsYData1: [],
				lineChartsYData2: [],
				chartsLeftTxt: '媒体收益(¥)',
				chartsRightTxt: '',
				searchHeight: 108,
				// 是否为媒介角色：roleType 仅包含 MEDIUM 时为 true
				isMediumRole: false,
				// 媒介角色自定义指标白名单
				mediumTHeadProps: ['estimateProfit', 'reqNum', 'succNum', 'succReqRate', 'showNum', 'succShowRate', 'deductClickNum', 'deductClickRate', 'ecpm', 'pv', 'uv', 'deu'],
			}
		},
		computed: {
			// 获取侧导航折叠状态，使固定筛选栏跟随主内容区域移动
			getIsCollapseStatus() {
				return this.$store.getters.getIsCollapseStatus
			},
			// 桌面端维度少于 5 个时固定维度列，平板和手机端始终不固定
			shouldFixDimensionColumn() {
				return !this.isMobileOrTablet && this.tHeaderQueryChecked.length < 5
			},
			// 媒介角色隐藏广告网络、广告源、聚合SDK版本、广告网络SDK版本维度
			visibleTHeaderQueryData() {
				if (!this.isMediumRole) return this.tHeaderQueryData;
				return this.tHeaderQueryData.filter(item => ![8, 9, 7, 11].includes(item.valueNum));
			},
			// 判断维度是否展示pv uv
			hasChecked() {
				return this.tHeaderQueryChecked.some(item => [5,6,8,9,11].includes(item));
			},
			// 判断表头是否包pv、uv
			hasRequiredPropsPUV() {
				const requiredProps = ['pv', 'uv'];
				return requiredProps.some(prop =>
					this.tHeadCheckedList.some(item => item.prop === prop)
				);
			},
			// 判断表头是否包含API数据
			hasRequiredProps() {
				const requiredProps = ['apiIncome', 'apiReqNum', 'apiSuccNum', 'apiSuccRate', 'apiShowNum', 'apiUniqueClickNum',
					'apiUniqueClickRate', 'apiEcpm'
				];
				return requiredProps.some(prop =>
					this.tHeadCheckedList.some(item => item.prop === prop)
				);
			},
			// 判断表头是否包含媒体维度的表头
			hasThChannelProps() {
				const requiredProps = ['reqNum', 'succNum', 'succReqRate', 'succShowRate'];
				return requiredProps.some(prop =>
					this.tHeadCheckedList.some(item => item.prop === prop)
				);
			},
			// 判断是否包含渠道维度
			hasMediaProps() {
				const requiredProps = [8, 9, 11];
				return requiredProps.some(prop =>
					this.tHeaderQueryChecked.some(item => item === prop)
				);
			},
			// 判断是否包含..."率"...
			hasLeftRate() {
				const requiredProps = ['succReqRate', 'succShowRate', 'platformSuccReqRate','platformSuccShowRate','deductClickRate','apiSuccRate',
				'apiUniqueClickRate','reqGapRate','reqSuccGapRate','showGapRate','clickGapRate','ecpmGapRate','incomeGapRate'];
				if(this.chartsQueryData.checked1){
					return requiredProps.some(prop => this.chartsQueryData.checked1 == prop);
				}else{
					return false
				}
			},
			hasRightRate() {
				const requiredProps = ['succReqRate', 'succShowRate', 'platformSuccReqRate','platformSuccShowRate','deductClickRate','apiSuccRate',
				'apiUniqueClickRate','reqGapRate','reqSuccGapRate','showGapRate','clickGapRate','ecpmGapRate','incomeGapRate'];
				if(this.chartsQueryData.checked2){
					return requiredProps.some(prop => this.chartsQueryData.checked2 == prop);
				}else{
					return false
				}
			},
		},
		watch: {
			// 侧导航宽度变化后重新计算固定筛选栏占用的页面高度
			getIsCollapseStatus() {
				this.$nextTick(() => this.updateSearchHeight())
			},
		},
		mounted() {
			this.initTableFixedMediaQuery();
			this.initLoginRole();
			this.$nextTick(() => this.updateSearchHeight())
			this.tHeadAllList.forEach((category, categoryIndex) => {
				const foundItem = category.list.forEach(items => {
					// this.$set(items, 'checked', true);
					// if(items.prop !== 'platformReqNum' && items.prop !== 'platformSuccNum'&&items.prop !== 'platformSuccReqRate'&&items.prop !== 'platformSuccShowRate'){
						
					// }
					if(items.prop == 'estimateProfit'){
						items['isDisable'] = true
					}else{
						items['isDisable'] = false
					}
					this.chartsSelectList.push(items);
				});
			});
			this.dateInit();
			// this.drawLineCharts();
			this.getCompanyOption();
			let tHeadCache = this.getTHeadCache();
			if (tHeadCache) {
				this.tHeadCheckedList = tHeadCache
			} else {
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
			}
			this.applyMediumTHeadLimit();
			// this.getOSOption();
			this.getMediaAppOption();
			this.getNetworkOtions();
			this.getAccountOptions();
			// this.getADTypeOption();
			this.getMediaAdsOption(2, null); // 获取聚合广告位下拉列表
			this.getChannelAdsOption(2, null);
			this.getChartData();
			this.getTableData();
		},
		beforeDestroy() {
			// 组件销毁时移除媒体查询监听，避免重复绑定
			if (!this.tableFixedMediaQuery) return
			if (this.tableFixedMediaQuery.removeEventListener) {
				this.tableFixedMediaQuery.removeEventListener('change', this.updateTableFixedState)
			} else {
				this.tableFixedMediaQuery.removeListener(this.updateTableFixedState)
			}
		},
		methods: {
			// 更新固定筛选栏高度，避免换行后遮挡下方内容
			updateSearchHeight() {
				const searchElement = this.$refs.searchTops
				if (searchElement) this.searchHeight = searchElement.offsetHeight
			},
			// 初始化表格固定列媒体查询，并监听平板、手机端视口变化
			initTableFixedMediaQuery() {
				this.tableFixedMediaQuery = window.matchMedia('(max-width: 1024px)')
				this.updateTableFixedState(this.tableFixedMediaQuery)
				if (this.tableFixedMediaQuery.addEventListener) {
					this.tableFixedMediaQuery.addEventListener('change', this.updateTableFixedState)
				} else {
					this.tableFixedMediaQuery.addListener(this.updateTableFixedState)
				}
			},
			// 更新设备状态，并在固定列变化后重新计算表格布局
			updateTableFixedState(mediaQueryEvent) {
				this.isMobileOrTablet = mediaQueryEvent.matches
				this.$nextTick(() => {
					if (this.$refs.multipleTable) this.$refs.multipleTable.doLayout()
					this.updateSearchHeight()
				})
			},
			// 拼接广告位类型与渲染类型展示文案
			getAdTypeRenderText(row) {
				if(!row.type){
					return '-'
				}
				if(row.isSelfRender === 1||row.isSelfRender === '1'){
					return `${row.type}（自渲染）`
				}
				if(row.isSelfRender === 0||row.isSelfRender === '0'){
					return `${row.type}（模版渲染）`
				}
				return row.type
			},
			// 初始化登录角色，判断当前登录用户是否为媒介角色
			initLoginRole() {
				let roleType = [];
				if (sessionStorage.getItem('sdk-roleType')) {
					roleType = JSON.parse(sessionStorage.getItem('sdk-roleType'));
				}
				this.isMediumRole = Array.isArray(roleType) && roleType.length === 1 && roleType.includes('MEDIUM');
				if (this.isMediumRole) {
					this.clearMediumHiddenQuery();
					this.applyMediumTHeadLimit();
				}
			},
			// 清空媒介角色不可见筛选项和维度，避免隐藏条件继续参与查询
			clearMediumHiddenQuery() {
				['platformId', 'platformNetworkId', 'adsId', 'sdkVersion', 'appProperty'].forEach(key => {
					this.$delete(this.queryData, key);
				});
				this.adsSelectFormChannel = {};
				this.tHeaderQueryChecked = this.tHeaderQueryChecked.filter(item => ![8, 9, 7, 11].includes(item));
			},
			// 媒介角色只保留允许展示的自定义指标，并同步清理媒介专用缓存
			applyMediumTHeadLimit() {
				if (!this.isMediumRole) return;
				this.tHeadAllList = this.tHeadAllList.map(item => {
					return {
						...item,
						list: this.filterMediumTHeadList(item.list)
					}
				}).filter(item => item.list.length > 0);
				this.tHeadCheckedList = this.filterMediumTHeadList(this.tHeadCheckedList);
				this.tHeadCheckShowList = this.filterMediumTHeadList(this.tHeadCheckShowList);
				if (this.tHeadCheckedList.length > 0 || localStorage.getItem(this.getTHeadStorageKey())) {
					localStorage.setItem(this.getTHeadStorageKey(), JSON.stringify(this.tHeadCheckedList));
				}
			},
			// 根据媒介角色指标白名单过滤指标列表
			filterMediumTHeadList(list) {
				return (list || []).filter(item => this.mediumTHeadProps.includes(item.prop));
			},
			// 自定义指标缓存 key：媒介角色使用独立 key，避免影响其他角色缓存
			getTHeadStorageKey() {
				return this.isMediumRole ? 'sdk-comprehensiveTHead-MEDIUM' : 'sdk-comprehensiveTHead';
			},
			// 获取自定义指标缓存；媒介首次进入时可读取旧公共缓存做过滤，但不会改写公共缓存
			getTHeadCache() {
				let cache = localStorage.getItem(this.getTHeadStorageKey());
				if (cache) {
					let cacheList = JSON.parse(cache);
					if (cacheList && cacheList.length > 0) return cacheList;
				}
				if (this.isMediumRole) {
					let commonCache = localStorage.getItem('sdk-comprehensiveTHead');
					return commonCache ? JSON.parse(commonCache) : null;
				}
				return null;
			},
			// 日期选择器初始化
			dateInit() {
			  let endDate = new Date();
			  endDate.setDate(endDate.getDate() - 1);      // 昨天（不包含今天）
			  let startDate = new Date(endDate);           // 基于 endDate 创建副本
			  startDate.setDate(startDate.getDate() - 6);  // 再向前推6天，共7天范围
			  			
			  const formatDate = (date) => {
			      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
			  };
			  this.datePicker = [formatDate(startDate), formatDate(endDate)];
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取配置后的广告网络下拉选择列表
			async getNetworkOtions(){
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct);
				this.networkOptions = res.data
			},
			drawLineCharts() {
				let chartDom = document.getElementById('lineChart');
				// 1. 销毁旧实例（如果存在）
				if (echarts.getInstanceByDom(chartDom)) {
					echarts.dispose(chartDom);
				}
				let myChart = echarts.init(chartDom);
				let option = {
					legend: {
						bottom: '2%',
					},
					grid: {
						bottom: '8%',
						right: '2%',
						left: '2%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						backgroundColor: "#fff",
						textStyle: {
							// color: '#007FFF',
							fontSize: 12
						},
						valueFormatter: function(value) {
							// console.log(index);
							return value;
						}
						// showContent: false
					},
					xAxis: [{
						type: 'category',
						// data: ['2023-06-03', '2023-06-04', '2023-06-05', '2023-06-06', '2023-06-07', '2023-06-08',
						// 	'2023-06-09'
						// ],
						data: this.lineChartsXData,
						axisPointer: {
							// type: 'shadow'
						}
					}],
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: this.hasLeftRate? '{value} %':'{value}' // 在这里将y轴的标签格式设置为百分比形式
						},
						// name: '预估收益（￥）',
						name: this.chartsLeftTxt,
						nameTextStyle: { // y轴name的样式调整
							color: '#666666',
							fontSize: 12,
							padding: [20, 0, 0, 40] // 加上padding可以调整其位置
						},
						nameGap: 30, // y轴name与横纵坐标轴线的间距
						splitLine: {
							lineStyle: {
								type: 'dashed', //设置刻度线条为虚线
								width: 1,
								color: '#DFE6F2'
							},
							show: true,
						},
						// min: 0,
						// max: 30,
						alignTicks: true,
						// interval: 5,
					}, {
						type: 'value',
						axisLabel: {
							formatter: this.hasRightRate? '{value} %':'{value}' // 在这里将y轴的标签格式设置为百分比形式
						},
						// name: '流量请求量',
						name: this.chartsRightTxt,
						position: 'right',
						nameTextStyle: { // y轴name的样式调整
							color: '#666666',
							fontSize: 12,
							padding: [20, 20, 0, 0] // 加上padding可以调整其位置
						},
						nameGap: 30, // y轴name与横纵坐标轴线的间距
						splitLine: {
							lineStyle: {
								type: 'dashed', //设置刻度线条为虚线
								width: 1,
								color: '#DFE6F2'
							},
							show: true,
						},
						// min: 0,
						// max: 100,
						alignTicks: true,
						// minInterval: 1,
						// interval: 5,
					}, ],
					series: [{
							// name: '预估收益(¥)',
							name: this.chartsLeftTxt,
							type: 'line',
							// symbol: "none",
							itemStyle: {
								color: "#007FFF", // 数据颜色
								gradientColorNum: 1,
							},
							// yAxisIndex: 1,
							tooltip: {
								valueFormatter: (value) => {
									if(this.hasLeftRate){
										return value + '%';
									}else{
										return value;
									}
									// return value + ' 个';
								}
							},
							// data: [0, 15, 17, 10, 25, 15, 20],
							data: this.lineChartsYData1,
							smooth: 0.5,
							yAxisIndex: 0,
						},
						{
							// name: '流量请求量',
							name: this.chartsRightTxt,
							type: 'line',
							// symbol: "none",
							itemStyle: {
								color: "#21CEBA", // 数据颜色
								gradientColorNum: 1,
							},
							// yAxisIndex: 1,
							tooltip: {
								valueFormatter: (value) => {
									if(this.hasRightRate){
										return value + '%';
									}else{
										return value;
									}
								}
							},
							// data: [15, 10, 5, 80, 30, 10, 55],
							data: this.lineChartsYData2,
							smooth: true,
							yAxisIndex: 1,
						}
					]
				}
				option && myChart.setOption(option);
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				const classNames = [];
				// 判断当前行是否在 expandedRows 列表中
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.id === row.id);
				if (isExpanded) {
					classNames.push('success-row');
				}
				// 检查 adsId 是否存在
				if (!row.adsId) {
					classNames.push('icon-no');
				}
				return classNames.join(' ');
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryData.mediaCompany,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取广告位下拉列表
			async getMediaAdsOption() {
				let res = await this.$http.get(this.$api.common.mediaAdsOption);
				this.mediaAdsOptions = res.data
			},
			async getChartData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if (this.adsSelectForm.value) {
					data['adsId'] = this.adsSelectForm.value
				}
				if (this.appSelectForm.value) {
					data['appId'] = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel.value) {
					data['platformAdsId'] = this.adsSelectFormChannel.value
				}
				let groupBys = []
				if (this.chartsQueryData.checked1) {
					groupBys.push(this.chartsQueryData.checked1)
				}
				if (this.chartsQueryData.checked2) {
					groupBys.push(this.chartsQueryData.checked2)
				}
				data['groupBy'] = groupBys.join(',');
				let res = await this.$http.post(this.$api.dataManage.apiChart, data);
				this.lineChartsXData = []
				this.lineChartsYData1 = []
				this.lineChartsYData2 = []
				if (res.data.left && res.data.left.length > 0) {
					res.data.left.forEach(item => {
						this.lineChartsXData.push(item.recordDate);
						this.lineChartsYData1.push(item.total);
					});
				}
				if (res.data.right && res.data.right.length > 0) {
					res.data.right.forEach(items => {
						this.lineChartsYData2.push(items.total);
					});
				}
				// if (this.lineChartsYData1.length > 0) {
				// 	this.drawLineCharts();
				// }
				this.drawLineCharts();
				// this.lineChartsXData
				// console.log(res);
			},
			chartsSelectChange(e, type) {
				if (!this.chartsQueryData.checked1 && !this.chartsQueryData.checked2) {
					this.$message.warning('请至少选择一个维度');
					return
				}
				this.chartsSelectList.forEach((item,index)=>{
					this.$set(item, 'isDisable', false);
				})
				if (e != '') {
					this.chartsSelectList.forEach(item => {
						if (item.prop == e) {
							if (type == 1) {
								this.chartsLeftTxt = item.label
							} else {
								this.chartsRightTxt = item.label
							}
						}
					});
				}
				// 判断是否禁用选项
				this.$nextTick(()=>{
					// console.log(this.chartsQueryData.checked1)
					this.chartsSelectList.forEach((items,index)=>{
						if(items.prop == this.chartsQueryData.checked1 || items.prop == this.chartsQueryData.checked2){
							this.$set(items, 'isDisable', true);
						}
					})
					if(this.adsSelectFormChannel.value || this.queryData.platformNetworkId){
						this.hasChartsOptionsDisable();
					}
					this.$forceUpdate();
					// console.log(this.chartsSelectList)
				})
				this.getChartData();
				// console.log(e)
			},
			chartsClear(type) {
				if (type == 1) {
					this.chartsLeftTxt = ''
				} else {
					this.chartsRightTxt = ''
				}
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if (this.adsSelectForm.value) {
					data['adsId'] = this.adsSelectForm.value
				}
				if (this.appSelectForm.value) {
					data['appId'] = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel.value) {
					data['platformAdsId'] = this.adsSelectFormChannel.value
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				if (this.hasMediaProps) {
					data['isMedia'] = false
				} else {
					data['isMedia'] = true
				}
				let res = await this.$http.post(this.$api.dataManage.apiReportList, data);
				if (res.code == 1) {
					this.tableData = res.data.data.list
					this.total = res.data.data.totalRecord
					if(this.tableData.length>0){
						let obj = {
							recordTime: '合计',
							companyName: '-',
							mediaAppId: '',
							type: '-',
							os: '-',
							mediaAdId: '',
							platAdsId: '',
							platformName: '-',
							sdkVersion: '-',
							platformVersion: '-',
							channelEstimateProfit: res.data.channelEstimateProfit !== null ? res.data.channelEstimateProfit : '-',
							divideEstimateProfit: res.data.divideEstimateProfit !== null ? res.data.divideEstimateProfit : '-',
							channelEcpm: res.data.channelEcpm !== null ? res.data.channelEcpm : '-',
							estimateProfit: res.data.estimateProfit !== null ? res.data.estimateProfit : '-',
							reqNum: res.data.reqNum !== null ? res.data.reqNum : '-',
							succNum: res.data.succNum !== null ? res.data.succNum : '-',
							succReqRate: res.data.succReqRate !== null ? res.data.succReqRate : '-',
							showNum: res.data.showNum !== null ? res.data.showNum : '-',
							succShowRate: res.data.succShowRate !== null ? res.data.succShowRate : '-',
							clickNum: res.data.clickNum !== null ? res.data.clickNum : '-',
							uniqueClickNum: res.data.uniqueClickNum !== null ? res.data.uniqueClickNum : '-',
							deductClickNum: res.data.deductClickNum !== null ? res.data.deductClickNum : '-',
							clickRate: res.data.clickRate !== null ? res.data.clickRate : '-',
							uniqueClickRate: res.data.uniqueClickRate !== null ? res.data.uniqueClickRate : '-',
							deductClickRate: res.data.deductClickRate !== null ? res.data.deductClickRate : '-',
							ecpm: res.data.ecpm !== null ? res.data.ecpm : '-',
							pv: res.data.pv !== null ? res.data.pv : '-',
							uv: res.data.uv !== null ? res.data.uv : '-',
							deu: res.data.deu !== null ? res.data.deu : '-',
							appDeu: res.data.appDeu !== null ? res.data.appDeu : '-',
							fillRate: res.data.fillRate !== null ? res.data.fillRate : '-',
							avgShowNum: res.data.avgShowNum !== null ? res.data.avgShowNum : '-',
							finishNum: res.data.finishNum !== null ? res.data.finishNum : '-',
							finishRate: res.data.finishRate !== null ? res.data.finishRate : '-',
							apiIncome: res.data.apiIncome !== null ? res.data.apiIncome : '-',
							apiReqNum: res.data.apiReqNum !== null ? res.data.apiReqNum : '-',
							apiSuccNum: res.data.apiSuccNum !== null ? res.data.apiSuccNum : '-',
							apiSuccRate: res.data.apiSuccRate !== null ? res.data.apiSuccRate : '-',
							apiShowNum: res.data.apiShowNum !== null ? res.data.apiShowNum : '-',
							apiUniqueClickNum: res.data.apiUniqueClickNum !== null ? res.data.apiUniqueClickNum : '-',
							apiDeductClickNum: res.data.apiDeductClickNum !== null ? res.data.apiDeductClickNum : '-',
							apiUniqueClickRate: res.data.apiUniqueClickRate !== null ? res.data.apiUniqueClickRate : '-',
							apiDeductClickRate: res.data.apiDeductClickRate !== null ? res.data.apiDeductClickRate : '-',
							apiEcpm: res.data.apiEcpm !== null ? res.data.apiEcpm : '-',
							reqGapRate: res.data.reqGapRate !== null ? res.data.reqGapRate : '-',
							reqSuccGapRate: res.data.reqSuccGapRate !== null ? res.data.reqSuccGapRate : '-',
							showGapRate: res.data.showGapRate !== null ? res.data.showGapRate : '-',
							clickGapRate: res.data.clickGapRate !== null ? res.data.clickGapRate : '-',
							ecpmGapRate: res.data.ecpmGapRate !== null ? res.data.ecpmGapRate : '-',
							incomeGapRate: res.data.incomeGapRate !== null ? res.data.incomeGapRate : '-',
							platformReqNum: res.data.platformReqNum !== null ? res.data.platformReqNum : '-',
							platformSuccNum: res.data.platformSuccNum !== null ? res.data.platformSuccNum : '-',
							platformSuccReqRate: res.data.platformSuccReqRate !== null ? res.data.platformSuccReqRate : '-',
							platformSuccShowRate: res.data.platformSuccShowRate !== null ? res.data.platformSuccShowRate : '-',
							avgReqNum: res.data.avgReqNum !== null ? res.data.avgReqNum : '-',
						}
						this.tableData.unshift(obj)
					}
				}
			},
			checkBoxQueryChange(e, item, index) {
				let targetIndex = this.tHeaderQueryData.findIndex(items => items.valueNum === item.valueNum);
				if (targetIndex !== -1) {
					this.tHeaderQueryData[targetIndex].checked = e
				}
				
				this.dimensionCheckAll = this.tHeaderQueryChecked.length === this.visibleTHeaderQueryData.length
				this.isDimensionIndeterminate = this.tHeaderQueryChecked.length > 0 &&  this.tHeaderQueryChecked.length < this.visibleTHeaderQueryData.length
				this.currentPage = 1
				this.getTableData();
			},
			handleCheckAllChangeDim(val){
				this.tHeaderQueryChecked = []
				if(val){
					this.visibleTHeaderQueryData.forEach((item) => {
						this.tHeaderQueryChecked.push(item.valueNum)
					})
				}
				this.isDimensionIndeterminate = false;
				
				this.currentPage = 1
				this.getTableData();
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			handleSizeChangeDrawer(val) {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = val
				this.getExpendTableData();
			},
			handleCurrentChangeDrawer(val) {
				this.currentPageDrawer = val
				this.getExpendTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.adsSelectForm = {}
				this.appSelectForm = {}
				this.adsSelectFormChannel = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getChartData();
				this.getTableData();
			},
			addTableData() {
				this.companyFormData = {}
				this.companyDrawerShow = true
			},
			editTable(row, index) {
				row['editShow'] = true
				this.$set(this.tableData, index, row)
			},
			async editConfirm(row, index) {
				row['editShow'] = false
				this.$set(this.tableData, index, row)
				let data = {
					id: row.id,
					showNum: row.showNum,
					deductClickNum: row.deductClickNum,
					estimateProfit: row.estimateProfit,
					ecpm: row.ecpm
				}
				let res = await this.$http.post(this.$api.dataManage.mediaIncomeEdit, data);
				if (res.code == 1) {
					this.$message.success('编辑成功');
					this.getTableData();
				}
			},
			confirmDrawerQuery() {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = 10
				this.getExpendTableData();
			},
			// 表格展开方法
			handleExpandChange(row, expanded) {
				this.expandedRows = expanded
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.id === row.id);
				if (isExpanded) {
					this.tableData.forEach((item, index) => {
						if (row.id == item.id) {
							this.adsIdDrawer = row.adsId
							this.getExpendTableData(row, index);
						}
					})
				}
			},
			async getExpendTableData(row, index) {
				let data = {
					startDate: row.recordTime,
					endDate: row.recordTime,
					adsId: this.adsIdDrawer
				}
				// if (this.datePicker && this.datePicker.length > 0) {
				// 	data.startDate = this.datePicker[0];
				// 	data.endDate = this.datePicker[1];
				// }
				// data = {...data,...this.queryDataDrawer}
				let res = await this.$http.post(this.$api.dataManage.channelProfit, data);
				if (res.code == 1) {
					this.tableData[index].tabList = res.data
				}
				for (let i = 0; i < this.tableData.length; i++) {
					for (let j = 0; j < this.expandedRows.length; j++) {
						if (this.expandedRows[j].id == this.tableData[i].id) {
							this.expandedRows.splice(j, 1, this.tableData[i])
						}
					}
				}
				this.$forceUpdate();
			},
			channelDataDrawerOpen(row, index) {
				this.adsIdDrawer = row.adsId
				this.getExpendTableData();
				this.channelDataDrawerShow = true
			},
			closeDrawer() {
				this.currentPageDrawer = 1
				this.pageSizeDrawer = 10
				this.channelDataDrawerShow = false
			},
			confirmCompany(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.companyFormData;
						let res = await this.$http.post(this.$api.companyList, data);
						this.$message.success('编辑成功');
						this.closeDrawer();
						this.getTableData();
					}
				});
			},
			// 收益同步
			async mediaAsync(row) {
				let data = row.length ? row : [row]
				let res = await this.$http.post(this.$api.dataManage.mediaIncomeAsync, data);
				if (res.code == 1) {
					this.$message.success('同步成功');
					this.getTableData();
				}
			},
			// 一键同步
			mediaSyncAll() {
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择同步项！");
					return
				}
				data = data.map(item => {
					return item.id
				})
				this.$confirm('此操作将同步收入, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$refs.multipleTable.clearSelection(); // 清空选项
					this.mediaAsync(data);
				}).catch();
			},
			// 复选框
			handleSelectionChange(val) {
				this.handleSelection = val.map(res => {
					return {
						"reviewReduce": res.cut,
						"id": res.id
					}
				})
			},
			// 复选框控制
			checkSelectable(row, index) {
				// console.log(row.rstate);
				return !(index === 0)
			},
			// 导出
			async appExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if (this.tHeaderQueryChecked.length > 0) {
					data['groupByIdList'] = this.tHeaderQueryChecked;
				}
				let res = await this.$http.post(this.$api.dataManage.apiReportExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}综合报表数据.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			appSeleteChange(e) {
				this.appSelectForm = e
				this.mediaAdsOptions = []
				this.adsSelectForm = {}
				this.getMediaAdsOption(2);
			},
			appRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				}, 300)
			},
			adsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectForm = e
				}
			},
			adsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			// 获取媒体广告位下拉列表
			async getMediaAdsOption(type, query = null) {
				let data = {
					adsName: query,
					appId: this.appSelectForm.value ? this.appSelectForm.value : ''
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
			},
			// 是否需要禁用图表下拉部分选项
			hasChartsOptionsDisable(){
				if(!this.adsSelectFormChannel.value && !this.queryData.platformNetworkId){
					this.chartsSelectList.forEach((item,index)=>{
						if(item.prop == 'reqNum' || item.prop == 'succNum' || item.prop == 'succReqRate' || item.prop == 'showNum' || item.prop == 'succShowRate'){
							this.$set(item, 'isDisable', false);
						}
					})
				}else{
					this.chartsSelectList.forEach((item,index)=>{
						if(item.prop == 'reqNum' || item.prop == 'succNum' || item.prop == 'succReqRate' || item.prop == 'showNum' || item.prop == 'succShowRate'){
							this.$set(item, 'isDisable', true);
						}
					})
				}
			},
			channelAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormChannel = e
				}
				this.hasChartsOptionsDisable();
			},
			networkOptionsChange(e){
				this.accountOptions = []
				this.queryData.platformNetworkId = ''
				if(e){
					this.getAccountOptions(e);
				}else{
					this.getAccountOptions();
				}
			},
			networkAccountChange(e){
				this.hasChartsOptionsDisable();
			},
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			channelAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getChannelAdsOption(2, query)
				}, 300)
			},
			// 获取渠道广告位下拉列表
			async getChannelAdsOption(type, query = null) {
				let data = {
					adsId: query
				}
				let res = await this.$http.post(this.$api.common.channelAdsOption, data);
				this.adsRemoteLoading = false
				this.channelAdsOptions = res.data
			},

			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			// 阻止默认上传
			uploadSet() {},
			// 导入
			async uploadFun(file, type) {
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.dataManage.mediaImport, formdata);
				if (res.code == 1) {
					this.$message.success(res.msg);
					this.getTableData();
				}
			},
			editTheadDialog() {
				this.tHeadDialogVisible = true
				let tHeadCache = this.getTHeadCache();
				if (tHeadCache) {
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(tHeadCache))
					this.tHeadCheckedList = JSON.parse(JSON.stringify(tHeadCache))
				} else {
					this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				}
				this.applyMediumTHeadLimit();
				// 初始化分组状态
				this.initGroupStates();
			},
			// 初始化分组状态
			initGroupStates() {
				// 重置所有分组的选中状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					category.groupChecked = false;
					category.isIndeterminate = false;
				});
				// 遍历选中的列，设置对应的 checked 状态
				this.tHeadCheckShowList.forEach((item) => {
					this.tHeadAllList.forEach((category, categoryIndex) => {
						const foundItem = category.list.find(items => items.label === item.label);
						if (foundItem) {
							this.$set(foundItem, 'checked', true);
						}
					});
				});
				// 更新所有分组的状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					this.updateGroupState(categoryIndex);
				});
			},
			closeTHeadDialog() {
				this.tHeadDialogVisible = false
			},
			confirmTHeadDialog() {
				if (this.isMediumRole) {
					this.tHeadCheckShowList = this.filterMediumTHeadList(this.tHeadCheckShowList);
				}
				if (this.tHeadCheckShowList.length <= 0) {
					this.$message.warning("请选择要展示的指标");
					return;
				}
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadCheckShowList));
				localStorage.removeItem(this.getTHeadStorageKey());
				localStorage.setItem(this.getTHeadStorageKey(), JSON.stringify(this.tHeadCheckedList))
				this.$message.success("保存成功");
				this.closeTHeadDialog();
			},
			// 单个选中
			checkChange(e, index, items, indexs) {
				if (e === true) {
					this.tHeadCheckShowList.push(items)
				} else {
					const idx = this.tHeadCheckShowList.findIndex(item => item.label === items.label);
					if (idx !== -1) {
						this.tHeadCheckShowList.splice(idx, 1);
					}
				}
				// 更新分组状态
				this.updateGroupState(index);
			},
			updateGroupState(groupIndex) {
				const group = this.tHeadAllList[groupIndex];
				if (!group) return;
				const list = group.list;
				const checkedCount = list.filter(item => item.checked).length;
				const totalCount = list.length;
				// 更新全选状态
				group.groupChecked = checkedCount === totalCount;
				// 更新半选状态
				group.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
			},
			// 分组选中
			handleGroupCheckChange(e, item, index) {
				item.isIndeterminate = false;
				if (e === true) {
					// 将 item.list 下的所有对象 checked 设为 true
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', true);
					});
					// 去重版本的合并
					const newItems = item.list.filter(newItem =>
						!this.tHeadCheckShowList.some(existingItem => existingItem.label === newItem.label)
					);
					this.tHeadCheckShowList = this.tHeadCheckShowList.concat(newItems);
				} else {
					const labelsToRemove = item.list.map(items => items.label);
					this.tHeadCheckShowList = this.tHeadCheckShowList.filter(item1 => !labelsToRemove.includes(item1.label));
					// 可选：取消分组选中时也将 checked 设为 false
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', false);
					});
				}
			},
			// 删除check-box的选中
			deleteTHeadChecked(item, index) {
				let foundGroupIndex = -1;
				// 遍历每个分类
				this.tHeadAllList.forEach((category, categoryIndex) => {
					// 在当前分类的 list 中查找匹配的项
					const foundItem = category.list.find(items => items.label === item.label);
					if (foundItem) {
						this.$set(foundItem, 'checked', false);
						// 记录找到的分组索引
						foundGroupIndex = categoryIndex;
					}
				});
				this.tHeadCheckShowList.splice(index, 1);

				// 如果找到了对应的分组，更新该分组的状态
				if (foundGroupIndex !== -1) {
					this.updateGroupState(foundGroupIndex);
				}
			},
			handleDragStart(e, item) {
				this.dragging = item.label;
			},
			handleDragEnd(e, item) {
				this.dragging = null
			},
			//首先把div变成可以放置的元素，即重写dragenter/dragover
			handleDragOver(e) {
				e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
			},
			handleDragEnter(e, item) {
				e.dataTransfer.effectAllowed = "move";
				// 如果拖拽目标是自身，则不处理
				if (item.label === this.dragging) {
					return;
				}
				try {
					const newItems = [...this.tHeadCheckShowList];
					// 查找源元素和目标元素的位置
					const src = newItems.findIndex(i => i.label === this.dragging);
					const dst = newItems.findIndex(i => i.label === item.label);
					// 验证索引有效性
					if (src === -1) {
						console.warn(`找不到源元素: ${this.dragging}`);
						return;
					}
					if (dst === -1) {
						console.warn(`找不到目标元素: ${item.label}`);
						return;
					}
					// 如果源和目标相同，不处理
					if (src === dst) {
						return;
					}
					// 移动元素
					const [movedItem] = newItems.splice(src, 1);
					newItems.splice(dst, 0, movedItem);
					this.tHeadCheckShowList = newItems;
				} catch (error) {
					console.error('拖拽操作出错:', error);
				}
			}
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
		padding-top: 0;
	}
	
	.topSearchs{
		position: fixed;
		left: 200px;
		right: 0;
		top: 98px;
		z-index: 10;
		background: #EFF3F5;
		padding: 10px;
		padding-right: 0;
		/* width: 100%; */
		box-sizing: border-box;
	}
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
		
		/* box-shadow: -4px 2px 6px 0px rgba(170, 170, 170, 0.1); */
	}

	/* 平板及手机端取消筛选栏固定定位，使其随页面内容正常滚动 */
	@media screen and (max-width: 1024px) {
		.topSearchs {
			left: auto !important;
			padding-right: 10px;
			position: static;
			right: auto;
			top: auto;
			width: 100%;
			z-index: auto;
		}
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	/deep/ .icon-no .el-table__expand-icon {
		display: none;
	}

	/deep/ .el-form-item__content {
		line-height: 32px;
	}
	
	.searchMenuRight{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 82px;
	}


	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}

	.tableBtns {
		height: 32px;
		margin-left: auto;
	}

	.chartsBox {
		background: #ffffff;
		/* margin-top: 10px; */
	}

	.chartsRow {
		height: 63px;
		/* border-bottom: 1px solid #DFE2E7; */
		padding: 0 24px;
		box-sizing: border-box;
		align-items: center;
	}

	.chartsTips {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin-right: 16px;
	}

	#lineChart {
		height: 550px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		/* padding-right: 30px; */
		margin-top: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}


	.el_tables /deep/ tr {
		background-color: #F6FEFF !important;
	}

	.el_tables {
		font-size: 12px !important;
		background-color: #F6FEFF !important;
	}

	.el_table /deep/.el-table__expanded-cell {
		padding: 0 !important;
		padding-left: 100px !important;
		background-color: #F6FEFF !important;
	}

	.el_table /deep/ .caret-wrapper {
		/* height: 24px;
		line-height: 24px; */
	}

	/deep/ .success-row {
		background-color: #EBFAFF !important;
	}

	.upload-demo {
		margin-left: 10px;
	}



	.tHeadRow {
		/* align-items: center; */
		margin-bottom: 20px;
	}

	.tHeadleftTips {
		font-size: 12px;
		margin-right: 20px;
	}

	.menu-right {
		margin-left: auto;
		/* margin-bottom: 20px; */
		align-items: center;
	}

	.setLabel {
		margin-left: 10px;
		font-size: 30px;
		cursor: pointer;
	}

	.tHeadEditBox {
		border: 1px solid #C2CEDF;
		padding: 12px;
		box-sizing: border-box;
	}

	.tHeadAllList {
		width: 49%;
		height: 490px;
		overflow-y: auto;
	}

	.checkList {
		width: 100%;
		flex-wrap: wrap;
		/* padding-right: 15px; */
		box-sizing: border-box;
	}

	.el_check_box {
		margin-bottom: 15px;
		margin-right: 0;
		width: 50%;
	}

	/deep/.el-collapse-item__header {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 10px;
	}

	.tHeadCheckShowBox {
		width: 49%;
		background: #F0F2F5;
		padding: 16px 18px;
		box-sizing: border-box;
	}

	.tHeadCheckShowTitle {
		font-size: 14px;
		color: #4E5865;
	}

	.tHeadCheckShowTips {
		font-size: 12px;
		color: #8E98AA;
	}

	.tHeadCheckShowList {
		border: 1px solid #C3CDE0;
		border-bottom: none;
		margin-top: 8px;
		height: 420px;
		overflow-y: auto;
	}

	.tHeadCheckedOne {
		width: 100%;
		height: 34px;
		line-height: 34px;
		align-items: center;
		border-bottom: 1px solid #C3CDE0;
		padding: 0 8px;
		font-weight: 500;
		font-size: 14px;
		color: #4E5866;
		box-sizing: border-box;
		cursor: pointer;
	}

	.tHeadCheckedOne div {
		margin-left: 4px;
	}
	.tHeadCheckedOne img {
		width: 16px;
		height: 16px;
	}
	.tHeadCheckedOne i {
		font-size: 18px;
	}

	.tHeadFixedCheckList {
		flex-wrap: wrap;
		width: 40%;
	}

	.check-box-fixed {
		margin-bottom: 10px;
	}

	.dimensionalityCheckedTips {
		align-items: center;
		padding: 0 12px;
		height: 30px;
		background: rgba(0, 127, 255, 0.1);
		border-radius: 2px;
		border: 1px solid rgba(0, 127, 255, 0.2);
		box-sizing: border-box;
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		margin-bottom: 16px;
	}

	.dimensionalityCheckedTips img {
		width: 16px;
		height: 16px;
		margin-right: 2px;
		cursor: pointer;
	}
	
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
</style>
